/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type { HeadlessFormComponentSignature } from "ember-headless-form/components/headless-form";
import type { UserData } from "ember-wiser/-private/types";

interface Signature<DATA extends UserData> {
  Args: {
    form: HeadlessFormComponentSignature<DATA, unknown>["Blocks"]["default"][0];
  };
}
export default class CtcaeCustomBaseConsultFormCurrentWeightLoss<
  DATA extends UserData
> extends Component<Signature<DATA>> {}
